<template>
  <checkout-page></checkout-page>
</template>

<script>
  import CheckoutPage from '../CheckoutPage'

  export default {
    components: {
      CheckoutPage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/newSteps/Checkout.vue